"use client";

import { HOME_FAQ_INDICES } from "@marketing/home/lib/home-faq";
import { cn } from "@ui/lib";
import { ArrowRightIcon } from "lucide-react";
import { useTranslations } from "next-intl";

interface FaqSectionProps {
	className?: string;
	itemParams?: Record<number, Record<string, string | number>>;
}

export function FaqSection({ className, itemParams }: FaqSectionProps) {
	const t = useTranslations();

	return (
		<section
			className={cn("scroll-mt-20 border-t py-12 lg:py-16", className)}
			id="faq"
		>
			<div className="container mx-auto px-4">
				<div className="max-w-3xl mx-auto">
					<div className="text-center mb-12">
						<h2 className="text-3xl font-bold mb-4">
							{t("faq.title")}
						</h2>
						<p className="text-lg text-muted-foreground">
							{t("faq.description")}
						</p>
					</div>

					<div className="space-y-4">
						{HOME_FAQ_INDICES.map((index) => (
							<details
								key={index}
								className="group bg-background rounded-lg border"
							>
								<summary className="flex items-center justify-between w-full p-6 text-left cursor-pointer">
									<h3 className="font-semibold">
										{t(
											`faq.home.items.${index}.question` as any,
											itemParams?.[index],
										)}
									</h3>
									<div className="ml-4 flex-shrink-0">
										<ArrowRightIcon className="w-5 h-5 text-muted-foreground group-open:rotate-90 transition-transform" />
									</div>
								</summary>
								<div className="px-6 pb-6">
									<p className="text-muted-foreground">
										{t(
											`faq.home.items.${index}.answer` as any,
											itemParams?.[index],
										)}
									</p>
								</div>
							</details>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
